exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3h6BOcXe5rgJt2gWiPg7WW{overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
exports.locals = {
	"container": "_3h6BOcXe5rgJt2gWiPg7WW"
};